export const defaultValues = {
  name: "",
  code: "",
  codeIS: "",
  status: { label: "Не выбрано", value: undefined },
  level: { label: "Не выбрано", value: undefined },
  certificateValidityPeriod: null,
  replacementCourseIds: [{ value: undefined, label: "Нету данных" }],
};
